import React from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";

const styles = theme => ({
  root: {
    padding: "19px",
    marginTop: "3rem",
    backgroundColor: "#213262"//"#394764"
  },

  container: {
    flex: "1 1 100%",
    flexGrow: 1,
    maxWidth: "1200px",
    margin: "0 auto",
    color: "white"
  },
  text: {
    color: "white",
    fontSize: "13px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    }
  }
});

class Footer extends React.Component {
  render() {
    const { classes } = this.props;
    const appVersion = process.env.REACT_APP_VERSION
      ? process.env.REACT_APP_VERSION
      : "";
    return (
      <div className={classes.root}>
        <Container>
        {/* <div className={classes.container}> */}
          <Grid container spacing={10}>
            <Grid item xs={12} sm={6}>
              <Typography className={classes.text}>
                CONDA GmbH, Liechtensteinstrasse 111-115, 1090 Vienna, Austria
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography className={classes.text} align="right">
                Copyright © 2020. | Created with ❤ at conda
              </Typography>
            </Grid>
          </Grid>
          </Container>
        {/* </div> */}
        <span style={{ color: "#213262" }}>{appVersion}</span>
      </div>
    );
  }
}

export default withStyles(styles)(Footer);
